<template>
  <list :listTitle="$t('logs.label')" filterTitle="Filtro" :loading="loading" :total="logsTotal" :emitChangeOnCreated="false" @change="onChange" v-on:loadMore="loadMore" @clearFilters="clearFilters">
    <template slot="filters">
      <form-group label="Data">
        <el-date-picker
          v-model="createdDate"
          type="datetimerange"
          format="dd/MM/yyyy HH:mm"
          start-placeholder="Data Inicial"
          end-placeholder="Data Final">
        </el-date-picker>
      </form-group>

      <form-group :label="$t('token.label')">
        <select v-model="options.token" class="form-select">
          <option
            v-for="token in tokens"
            :key="token"
            :value="token.authorization">{{ token.description }} ({{ token.authorization }})
          </option>
        </select>
      </form-group>

      <form-group label="Endpoint">
        <input class="form-input" v-model="options.endpoint">
      </form-group>

      <form-group :label="$t('httpMethod.label')">
        <select v-model="options.method" class="form-select">
          <option :value=null>Todos</option>
          <option
            v-for="method in methods"
            :key="method"
            :value="method">{{ method }}</option>
        </select>
      </form-group>
    </template>

    <div class="l-col-12@md" v-if="dataLogs.length">
      <ul class="timeline">
        <log-card v-for="item in dataLogs" :key="item" :item="item"/>
      </ul>
    </div>
    <div class="l-col u-textCenter" v-else>
      <panel>Nenhum histórico encontrado.</panel>
    </div>
  </list>
</template>

<script>
  import List from '@/components/shared/list/Scroll'
  import Panel from '@/components/template/Panel'
  import { merge } from 'lodash'
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import LogCard from '@/components/tool/api/LogCard'

  export default {
    data: () => ({
      loading: false,
      options: {
        token: null,
        endpoint: null,
        method: null,
        createdStart: null,
        createdEnd: null,
        actionType: 'request'
      },
      createdDate: [],
      dataLogs: [],
      tokens: [],
      methods: [
        'GET',
        'POST',
        'PATCH',
        'DELETE',
        'PUT'
      ]
    }),
    async mounted () {
      this.loading = true

      try {
        this.tokens = await api.getAllTokens()
        if (this.tokens.length) {
          this.options.token = this.tokens[0].authorization
        }
      } catch (e) {
        this.tokens = []
      }

      this.loading = false
    },
    created () {
      merge(this.options, this.lastFilters)

      if (this.options.createdStart && this.options.createdEnd) {
        this.createdDate = [
          this.options.createdStart,
          this.options.createdEnd
        ]
      }
    },
    methods: {
      ...mapActions('logs', [
        'fetchApi',
        'fetchMoreApi'
      ]),
      async onChange (options) {
        this.loading = true

        merge(this.options, options)

        await this.fetchApi({
          options: this.options
        })

        this.loading = false
      },
      async loadMore (options) {
        merge(this.options, options)

        await this.fetchMoreApi({
          options: this.options
        })

        options.fetchingMore = false
      },
      clearFilters () {
        this.createdDate = []
        if (this.tokens.length) {
          this.options.token = this.tokens[0].authorization
        }
      }
    },
    computed: {
      ...mapFields({
        logsTotal: 'logs.total',
        logsLogs: 'logs.logs',
        lastFilters: 'logs.lastFetchOptions'
      })
    },
    watch: {
      logsLogs (logs) {
        this.dataLogs = []

        if (logs.length) {
          for (let i in this.logsLogs) {
            const log = this.logsLogs[i]

            this.dataLogs.push({
              id: i,
              icon_class: 'icon-info2',
              icon_status: 't-info',
              title: log.request.method + ' ' + log.request.endpoint + ` (${log.requestId})`,
              controls: [],
              updated: log.created,
              dataJSON: log
            })
          }
        }
      },
      createdDate (value) {
        if (value[0]) {
          this.options.createdStart = value[0]
        }

        if (value[1]) {
          this.options.createdEnd = value[1]
        }
      }
    },
    components: {
      LogCard,
      List,
      Panel,
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .timeline
    list-style: none
    padding: 20px 0 20px
    position: relative

    &:before
      background-color: #7872ff
      bottom: 0
      content: " "
      left: 50px
      margin-left: -1.5px
      position: absolute
      top: 0
      width: 3px
</style>



// WEBPACK FOOTER //
// Logs.vue?0ca602db